import * as each from "lodash/each";
import * as mapValues from "lodash/mapValues";

interface ApiConstantStates {
  base: string;
  pending: string;
  fulfilled: string;
  rejected: string;
  invalidated: string;
}
const states = {
  base: "",
  pending: "_PENDING",
  fulfilled: "_FULFILLED",
  rejected: "_REJECTED",
  invalidated: "_INVALIDATED"
};

class ApiConstants {
  login: ApiConstantStates = null;
  logout: ApiConstantStates = null;
  companies: ApiConstantStates = null;
  constructor() {
    each(this, (v, k) => {
      this[k] = mapValues(states, (state) => k + state);
    });
  }
}

export const apiConstants = new ApiConstants();

export const AUTH_ERROR = "AUTH_ERROR";



// WEBPACK FOOTER //
// ./src/redux/actions/constants.js